import { Injectable } from '@angular/core';
import { EventsFlowService as EventsFlowApiService } from '../../api/services';
import { lastValueFrom, Observable } from 'rxjs';
import { EventsFlowModel } from '../../api/models/events-flow-model';
import { LookupModel } from '../../api/models';

@Injectable()
export class EventsFlowService {
  constructor(private eventsFlowApiService: EventsFlowApiService) {}

  async deleteEventFlow(id: string): Promise<boolean> {
    const response = await lastValueFrom(
      this.eventsFlowApiService.eventsFlowDeleteEventsFlowById({
        id: id,
      }),
    );

    return response.success;
  }

  async getEventsFlowById(id: string): Promise<EventsFlowModel> {
    const response = await lastValueFrom(
      this.eventsFlowApiService.eventsFlowGetEventsFlowById({
        id: id,
      }),
    );

    return response.data;
  }

  async saveEventsFlow(reqData: EventsFlowModel) {
    await lastValueFrom(
      this.eventsFlowApiService.eventsFlowSaveEventsFlow({
        body: {
          model: reqData,
        },
      }),
    );
  }

  getCaregiverNoteSubject(): Observable<LookupModel[]> {
    return this.eventsFlowApiService.eventsFlowGetCaregiverNoteSubjects();
  }

  getPatientNoteReasons(): Observable<LookupModel[]> {
    return this.eventsFlowApiService.eventsFlowGetPatientNoteReasons();
  }
}
